<template>
	<div>
		<v-container>
			<v-row justify-space-between>
				<v-col>
					<v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
						<Graphs />
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import Graphs from "@/components/Graphs";

export default {
	components: {
		Graphs,
	},
	computed: {},
	mounted() {},
	data: () => ({
		loading: false,
		settings: {},
	}),
};
</script>

<style></style>
